import { render, staticRenderFns } from "./RemoteDevices.vue?vue&type=template&id=1ddfe9c8&"
import script from "./RemoteDevices.vue?vue&type=script&lang=js&"
export * from "./RemoteDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports